import { Alert, AlertBody, AlertIcon, IconButton, RiInformationLine, Stack } from 'component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorProductSubscriptionConfiguration } from '@/api/rest/resources/types/IndicatorProduct';

export const PendingWidget = ({
  insituIndicatorProductConfiguration,
  domain,
}: {
  insituIndicatorProductConfiguration: IndicatorProductSubscriptionConfiguration;
  domain?: string;
}) => {
  const { t } = useTranslation();
  const [displayAlert, setDisplayAlert] = useState(true);

  if (!displayAlert) {
    return null;
  }

  return (
    <Alert>
      <AlertIcon>
        <RiInformationLine size={20} />
      </AlertIcon>
      <AlertBody>
        <Stack direction='row'>
          <span className='grow'>
            {t(domain ? `global.widget.pendingWidgetWithDomain` : `global.widget.pendingWidget`, {
              name: insituIndicatorProductConfiguration.indicator_name,
              id: insituIndicatorProductConfiguration.id,
              domain,
            })}
          </span>
          <IconButton aria-label='Close' onClick={() => setDisplayAlert(false)}>
            <i className='ri-close-line' />
          </IconButton>
        </Stack>
      </AlertBody>
    </Alert>
  );
};
